import React from 'react';

interface IModalContext {
    visible: boolean;
    setVisible: (v: boolean) => void;
    hide: () => void;
}

export const ModalContext = React.createContext<IModalContext>({
    visible: false,
    setVisible: () => {},
    hide: () => {},
});
